export enum TooltipVariant {
    DEFAULT = 'variant-default',
    WARNING = 'variant-warning',
    ERROR = 'variant-error'
}
